import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getProjects: function ({
    limit = 999,
    page = 1,
    status,
    sort,
    client,
    dateStart,
    search,
    projectManager,
    projectType,
    parentProjectId,
    tags = []
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (status) query.push(`status[]=${status}`)
    if (client) query.push(`client[]=${client}`)
    if (sort) query.push(`sort[]=${sort}`)
    if (search) query.push(`search=${search}`)
    if (dateStart) query.push(`dateStart=${dateStart}`)
    if (projectManager) query.push(`projectManager[]=${projectManager}`)
    if (parentProjectId) query.push(`parentProjectId[]=${parentProjectId}`)
    if (projectType) query.push(`projectType[]=${projectType}`)
    if (tags.length) query.push(...tags)
    const apiAddress = search ? 'projects' : 'projects/withoutelastic'
    return instCred.get(`${apiAddress}?${query.join('&')}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/ProjectsList/api.js